import {ParamsSearchRequest} from "../services/api/stores";

const localitiesConf: woosmap.localities.AutocompleteParameters = {
    minLength: 0,
    data: 'advanced',
    types: ['locality', 'postal_code', 'address', 'admin_level', 'airport', 'train_station', 'metro_station', 'shopping', 'country'],
    // types: ['address', 'locality', 'postal_code'],
    components: {
    country: ["at", "de", "ch", "fr", "cz", "it", "hu"]
    },
};
const searchAPIParameters: ParamsSearchRequest = {
    stores_by_page: 25,
    // radius: 30000
};
const searchRadius = 30000;
const availableServices: Record<string, string>[] = [
    {serviceKey: 'WF', serviceName: 'Wireless Hotspot'},
    {serviceKey: 'CD', serviceName: 'Mobile Payment'},
    {serviceKey: 'DT', serviceName: 'Drive-Thru'},
    {serviceKey: 'DR', serviceName: 'Digital Rewards'},
    {serviceKey: 'hrs24', serviceName: 'Open 24 hours per day'},
    {serviceKey: 'WA', serviceName: 'Oven-warmed Food'},
    {serviceKey: 'LB', serviceName: 'LaBoulange'},
    {serviceKey: 'XO', serviceName: 'Mobile Order and Pay'},
    {serviceKey: 'VS', serviceName: 'Verismo'},
    {serviceKey: 'NB', serviceName: 'Nitro Cold Brew'},
    {serviceKey: 'CL', serviceName: 'Starbucks Reserve-Clover Brewed'},
];
const geoLocationAccuracyThreshold = 20; //kilometers
export default {
    availableServices: availableServices,
    searchAPIParameters: searchAPIParameters,
    localitiesConf: localitiesConf,
    searchRadius: searchRadius,
    geoLocationAccuracyThreshold: geoLocationAccuracyThreshold,
}
